// extracted by mini-css-extract-plugin
module.exports = {"container":"SignUpVerify_container__tRAf2","backButton":"SignUpVerify_backButton__uRXB4"};